































































import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  CreateQrCodeModal,
  InfiniteScroll,
  NetworkErrorEmptyState,
  QrCodeTile,
  VsLoading
} from '@/components'

import { EmptyState, MobileLayout } from '@/layouts/components'

import {
  AsyncState,
  BusinessUnit,
  ModalState,
  QrCode,
  QrCodeResourcePayload
} from '@/models'

import { RootState } from '@/store/state'

import { isFood } from '@/utils'

@Component({
  components: {
    CreateQrCodeModal,
    EmptyState,
    InfiniteScroll,
    MobileLayout,
    NetworkErrorEmptyState,
    QrCodeTile,
    VsLoading
  }
})
export default class QrCodes extends Vue {
  loadState = new AsyncState()
  createState = new ModalState()

  @State
  readonly businessUnit!: BusinessUnit | null

  @State((state: RootState) => state.qrCodes.total)
  readonly total!: number

  @State((state: RootState) => state.qrCodes.didLoadAll)
  readonly didLoadAll!: boolean

  get showFab () {
    return this.total > 0 || this.loadState.isResolved
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  @Getter('qrCodes/orderedQrCodes')
  readonly qrCodes!: QrCode[]

  @Action('qrCodes/loadQrCodePage')
  loadQrCodePage!: () => Promise<void>

  @Action('qrCodes/createQrCode')
  createQrCode!: (payload: QrCodeResourcePayload) => Promise<QrCode>

  created () {
    if (this.total === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadQrCodePage()
    )

    return this.qrCodes.length > 0
  }

  async handleCreateQrCode (payload: QrCodeResourcePayload) {
    try {
      const qrCode = await this.createState.handle(
        this.createQrCode(payload)
      )

      this.$router.push({
        name: 'QrCodeDetails',
        params: {
          qrCodeId: qrCode.id.toString()
        }
      })
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível criar novo QR code.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}
